// This allows passing a nonce for the style loader to
// make it work in strict CSP environments
if (window?.__webpack_nonce__) {
    __webpack_nonce__ = window.__webpack_nonce__;
}
